import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { productVersionList } from "../../redux/actions/productActions";
import "./productDetail.css";
import VersionTableData from "./VersionTableData";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";
import { useNavigate, useParams } from "react-router-dom";

const ProductVersionHistoryTable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [productVersionHistoryList, setProductVersionHistoryList] = useState(
    []
  );
  const [openStatus, setOpenStatus] = useState("");
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      productVersionList(
        {
          search,
          page,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
        },
        onSuccess,
        onError
      )
    );
  }, [page, status, search]);

  const onSuccess = (data) => {
    setLoading(false);
    setProductVersionHistoryList(data.data.data);
  };
  const onError = (err) => {
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"3%"}>
                  #
                </th>
                <th className="table-heads" width={"10%"}>
                  Product Id
                </th>
                <th className="table-heads" width={"14%"}>
                  Company’s Product ID
                </th>
                <th className="table-heads" width={"12%"}>
                  Name
                </th>
                <th className="table-heads" width={"15%"}>
                  Division
                </th>
                <th
                  ref={componentRef}
                  className="table-heads cursor_pointer"
                  width={"12%"}
                >
                  <span
                    onClick={() => setOpenStatus(!openStatus)}
                    className={openStatus ? "Medium_Purple" : ""}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="area_covered"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              setActive("active");
                              navigate(
                                `/product/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="area_covered"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              setActive("inactive");
                              navigate(
                                `/product/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/product/version-history?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads" width={"12%"}>
                  Updated By
                </th>
                <th className="table-heads" width={"14%"}>
                  Updated Date
                </th>
                <th className="table-heads-action" width={"12%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : productVersionHistoryList?.productVersionList?.length > 0 ? (
                <>
                  {productVersionHistoryList?.productVersionList?.map(
                    (eachRow, index) => (
                      <VersionTableData
                        key={eachRow.id}
                        data={eachRow}
                        index={index}
                        currentPage={
                          productVersionHistoryList?.pagination?.currentPage
                        }
                      />
                    )
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {productVersionHistoryList?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={productVersionHistoryList?.pagination?.currentPage}
              totalPages={productVersionHistoryList?.pagination?.totalPages}
              path={"/product/version-history"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProductVersionHistoryTable;
